// extracted by mini-css-extract-plugin
export default {"pagenationBar":"Pagenation_pagenationBar__pdVmA","pageButton":"Pagenation_pageButton__2yPBw","active":"Pagenation_active__vtb8U"};